import type React from 'react';

import { TableSettingsContextProvider } from '@vlabs/monokit/entities/events/context/TableSettingsContext';
import type { EventListPermissions } from '@vlabs/monokit/entities/events/event-list-table';
import { DEFAULT_EVENT_LIST_PERMISSIONS } from '@vlabs/monokit/entities/events/event-list-table';
import type { EventListFilters } from '@vlabs/monokit/entities/events/filters';
import {
  EventListFiltersProvider,
  EventListFilterMenuButton,
} from '@vlabs/monokit/entities/events/filters';
import { ToggleTopMatchSwitch } from '@vlabs/monokit/features';
import { FilterMenuProvider } from '@vlabs/monokit/shared/ui/filter-menu';
import {
  Page, PageContent, PageFilters, PageHeader,
} from '@vlabs/monokit/shared/ui/page';
import { DEFAULT_PAGE_SIZE } from '@vlabs/uikit/constants';

import st from './EventListPage.module.sass';
import { useEventListPageTranslation } from './i18n';

const DEFAULT_EVENT_LIST_FILTERS: EventListFilters = {
  page: 1,
  page_size: DEFAULT_PAGE_SIZE,
};

const FILTERS_STORAGE_KEY = 'filtersEventListPage';

interface EventListPageViewProps {
  includedAttributes?: string[];
  initialFilters?: Partial<EventListFilters>;
  fastFilters: React.ComponentType<{ includedAttributes: string[] }>;
  filterMenu: React.ComponentType<{ includedAttributes: string[] }>;
  viewer: React.ComponentType<{ permissions: EventListPermissions }>;
  permissions?: EventListPermissions;
}

function EventListPageView({
  includedAttributes = [],
  initialFilters = undefined,
  fastFilters: FastFilters,
  filterMenu: FilterMenu,
  viewer: Viewer,
  permissions = DEFAULT_EVENT_LIST_PERMISSIONS,
}: EventListPageViewProps): React.JSX.Element {
  const { t } = useEventListPageTranslation();

  return (
    <Page className={st.EventListPage}>
      <EventListFiltersProvider
        initialData={{ ...DEFAULT_EVENT_LIST_FILTERS, ...initialFilters }}
        storageKey={FILTERS_STORAGE_KEY}
      >
        <FilterMenuProvider>
          <PageContent>
            <TableSettingsContextProvider>
              <PageHeader title={t('title')}>
                <ToggleTopMatchSwitch />
                <EventListFilterMenuButton />
                {/* ponytail: ExportTaskButton не подключён — artemy-клиент не имеет tasks-ресурса */}
              </PageHeader>
              <FastFilters includedAttributes={includedAttributes} />
              <Viewer permissions={permissions} />
            </TableSettingsContextProvider>
          </PageContent>

          <PageFilters>
            <FilterMenu includedAttributes={includedAttributes} />
          </PageFilters>
        </FilterMenuProvider>
      </EventListFiltersProvider>
    </Page>
  );
}

export { EventListPageView };
